import { css } from "lit";
export default css `
    sl-alert::part(message) {
        padding-bottom: var(--global-padding);
        color: var(--font-color);
    }
    
    sl-alert.error::part(message) {
        color: var(--error-font-color);
    }

    sl-alert.warning::part(message) {
        color: var(--warn-300);
        
    }
    
    strong {
        font-weight: normal;
        font-family: var(--font-stack-bold), monospace;
    }
    
    .attention {
        margin-top: var(--global-space);
        margin-bottom: var(--global-space);
        border-top: none;
        border-right: none;
        border-bottom: none;
        border-left: 3px solid;
    }

    .error {
        color: var(--error-font-color);
        border-color: var(--error-color);
        border-left: 5px solid var(--error-color);
        animation-name: errorGlow;
        animation-duration: 1.2s;
        animation-iteration-count: infinite;
        animation-direction: alternate;
    }

    .context {
        border-left: 5px solid var(--font-color-sub1);
    }
    
    .info {
        color: var(--primary-color);
        border-color: var(--primary-color-lowalpha);
        border-left: 5px solid var(--primary-color);
    }
    

    .success {
        color: var(--terminal-text);
        border-color: var(--terminal-text);
        border-left: 5px solid var(--terminal-text);
    }

    .question {
        color: var(--secondary-color);
        border-color: var(--secondary-color);
        border-left: 5px solid var(--secondary-color);
    }


    .warning {
        color: var(--warn-300);
        border-color: var(--warn-200);
        border-left: 5px solid var(--warn-200);
        animation-name: warningGlow;
        animation-duration: 2s;
        animation-iteration-count: infinite;
        animation-direction: alternate;
    }
    
    @keyframes errorGlow {
        from {
            box-shadow: 0 0 1px var(--error-color-lowalpha);
            border-color: var(--error-color-verylowalpha);
         
        }
        to {
            border-color: var(--error-color);
            box-shadow: 0 0 8px var(--error-color);
        }
    }

    @keyframes warningGlow {
        from {
            box-shadow: 0 0 1px var(--warn-300-lowalpha);
            border-color: var(--warn-200-lowalpha);
        }
        to {
            border-color: var(--warn-300);
            box-shadow: 0 0 8px var(--warn-200);
        }
    }
`;
